module.exports = __webpack_public_path__ + "media/images/nocampaign-desktop-xl-6f14c56a211ba4ad08bf6ad27402b117.jpg";